module.exports = __webpack_public_path__ + "static/media/services-img1.415f3446.jpg";